import { useEffect } from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketCustomerInfo } from '../../../../state';
import { useGraphProfile } from '../../../../hooks';

const CustomerEmailEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);
  const { graphData } = useGraphProfile();

  useEffect(() => {
    if (graphData?.mail && !currentTicket?.customerInfo.customerEmail) {
      dispatch(updateTicketCustomerInfo({ customerEmail: graphData.mail }));
    }
  }, [dispatch, graphData, currentTicket?.customerInfo.customerEmail]);

  return (
    <TextField
      label="Customer Email"
      size="small"
      type="email"
      fullWidth
      value={currentTicket?.customerInfo.customerEmail || ''}
      placeholder="Auto-populated from user profile"
      disabled={true}
    />
  );
};

export default CustomerEmailEdit;
